import axios from 'axios';

export default class ApiClient {
    #client
    #apiKey = "2dec2f8e-1fa0-4c46-86b7-230648bf0d9c";
    #baseURL = "/templates/moebelfolien.at/materials/api";

    constructor() {
        this.#client = axios.create({
            responseType: 'json',
            baseURL: this.#baseURL,
            headers: {
                common: {
                    "X-Access-Token": this.#apiKey
                }
            }
        });
    }


    getMaterials = () => this.#client.get('/getMaterials.php');

}
